import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import { updateCrownsConfig } from "../apiConfigs";

export const updateCrownPointsApi = createAsyncThunk(
    "auth/crowns-and-badges/updateCrownPoints",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(updateCrownsConfig, payload);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
const intialState = { result: null, loading: false, error: null, message: "", success: false };
const updateCrownPointsSlice = createSlice({
    name: "auth/crowns-and-badges/updateCrownPoints",
    initialState: intialState,
    reducers: {
        resetUpdateCrownPoints: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(updateCrownPointsApi.pending, (state) => {
            state.loading = true;
            state.success = false;
        });
        builder.addCase(updateCrownPointsApi.fulfilled, (state, action) => {
            state.loading = false;
            state.result = action?.payload?.result;
            state.message = action?.payload?.message;
            state.success = true;
        });
        builder.addCase(updateCrownPointsApi.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.payload?.error;
            state.message = action?.payload?.message;
            state.success = false;
        });
    },
});
export const { resetUpdateCrownPoints } = updateCrownPointsSlice.actions;
export const updateCrownPointsReducer = updateCrownPointsSlice.reducer;
